<script>
import { Line, mixins } from 'vue-chartjs';

const { reactiveProp } = mixins;

export default Line.extend({
  props: ['options'],
  mixins: [reactiveProp],
  mounted() {
    /* eslint-disable no-underscore-dangle */
    this.renderChart(this.chartData, this.options);
    this.$emit('chartCreated', this._chart);
  },
});
</script>



// WEBPACK FOOTER //
// BaseLineChart.vue?568572b1